export class WidgetModel {
  name: string;
  preferredHeight: string;
  
  constructor() {
    this.name = "Untitled";
    this.preferredHeight = "155px";
  }
}
